import { IAppState } from '../../common/state';
import { AUD_WITH_NEIGHBORS_DISABLED } from '../../constants/experiments';
import { FOfferType } from '../../utils/category';
import { isAbUseExperimentGroup } from '../../utils/experiments/isAbUseExperimentGroup';
import { getOfferType } from '../getOfferType';
import { selectLocationId } from '../selectLocationId';

export function selectIsWithNeighborsFilterEnabled(state: IAppState): boolean {
  const regionId = selectLocationId(state);
  /**
   * @todo удалить в рамках CD-160335
   */
  const isExperimentEnabled = isAbUseExperimentGroup(state.abUseExperiments, AUD_WITH_NEIGHBORS_DISABLED, 'B');
  /**
   * В некоторых регионах отключаем фильтр c пригородами
   */
  const isRegionExcluded = state.featureToggle.withNeighborsFilterSettings.excludedRegions.includes(regionId);
  /**
   * фильтр отключается только в продаже квартир вторички
   */
  const isFlatSale = state.filters.jsonQuery._type === 'flatsale' && getOfferType(state) === FOfferType.FlatOld;

  const withNeighborsFilterDisabled = isExperimentEnabled && isRegionExcluded && isFlatSale;

  return !withNeighborsFilterDisabled;
}
